import type { RGLLayoutItem } from "./dashboard.types";
import { getColsForBreakpoint } from "./breakpoints";

export function findBestPosition(
    currentLayout: RGLLayoutItem[],
    widgetWidth: number,
    widgetHeight: number,
    breakpoint: string,
): { x: number; y: number } {
    const cols = getColsForBreakpoint(breakpoint);

    if (currentLayout.length === 0) {
        return { x: 0, y: 0 };
    }

    const occupied = new Set<string>();
    currentLayout.forEach((item) => {
        for (let y = item.y; y < item.y + item.h; y++) {
            for (let x = item.x; x < item.x + item.w; x++) {
                occupied.add(`${x},${y}`);
            }
        }
    });

    const maxY = Math.max(...currentLayout.map((item) => item.y + item.h));

    for (let y = 0; y <= maxY + 1; y++) {
        for (let x = 0; x <= cols - widgetWidth; x++) {
            // Check if this position is free
            let isFree = true;
            for (let dy = 0; dy < widgetHeight && isFree; dy++) {
                for (let dx = 0; dx < widgetWidth && isFree; dx++) {
                    if (occupied.has(`${x + dx},${y + dy}`)) {
                        isFree = false;
                    }
                }
            }

            if (isFree) {
                return { x, y };
            }
        }
    }

    return { x: 0, y: maxY + 1 };
}
